// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__31JY-","background":"main_background__3Pxcc"};